import React from 'react';
import { Link } from 'react-router-dom';
import useCars from '../../hooks/useCars';
import './ManageCar.css';


const ManageCar = () => {
     const [cars, setCars] = useCars();

     const handleDelete = id => {

          const proceed = window.confirm('Are you sure ?');
          if (proceed) {
               const url = `https://secure-springs-71035.herokuapp.com/service/${id}`;
               fetch(url, {
                    method: 'DELETE'
               })
                    .then(res => res.json())
                    .then(data => {
                         console.log(data);
                         const remaining = cars.filter(car => car._id !== id);
                         setCars(remaining);
                    })
          }

     }
     return (
          <div className=''>
               <h3 className='text-center text-primary fw-bold pb-3'>This is Delete Car Page</h3>
               {
                    cars.map(car => <div className='manage ' key={car._id}>
                         <div>
                              <img className='img-fluid' src={car.img} alt="" />
                         </div>
                         <div className='manage-info d-flex align-items-center'>
                              <div className='manage-details me-4'>
                                   <h5>{car.name}</h5>
                                   <p>{car.description}</p>
                                   <h6> Price $ {car.price}</h6>
                              </div>
                              <div className=" w-25 sm-w-100">
                                   <button className=' btn btn-primary' onClick={() => handleDelete(car._id)}>DELETE </button>

                              </div>
                         </div>
                    </div>)
               }
               <Link to='/addCar'>
                    <button className='me-auto fw-bold btn btn-primary my-5'>ADD NEW CAR 🡲</button>
               </Link>
          </div>
     );
};

export default ManageCar;